import { useEffect, useRef } from 'react';
import { createSeed } from '../../lib/designApi';

// The 'olt' seed is where the operator's OLT sits: a site (سایت). Only the label says so;
// the seed type, API and DB value stay 'olt'.
export const SEED_FA = { olt: 'سایت', odc: 'ODC', fat: 'FAT' };
export const SEED_COLOR = { olt: '#dc2626', odc: '#eab308', fat: '#8b5cf6' };

// Headless seed-placement: while `active`, a map click drops a site/ODC/FAT seed
// of `type` for the project. The type picker UI lives in the control panel
// (SeedTypePicker) so nothing floats over the map and collides with the search.
export function useSeedDrop({ map, active, projectId, type, onSaved }) {
  const busyRef = useRef(false);
  useEffect(() => {
    if (!map || !active || !projectId) return undefined;
    const prevCursor = map.get('draggableCursor');
    map.setOptions({ draggableCursor: 'crosshair' });
    const onClick = async (e) => {
      if (!e.latLng || busyRef.current) return;
      busyRef.current = true;
      const geometry = { type: 'Point', coordinates: [e.latLng.lng(), e.latLng.lat()] };
      const { error } = await createSeed(projectId, type, geometry);
      busyRef.current = false;
      if (error) { window.alert('ذخیره‌ی نقطه ناموفق بود'); return; }
      if (onSaved) onSaved();
    };
    const cl = map.addListener('click', onClick);
    return () => {
      window.google.maps.event.removeListener(cl);
      map.setOptions({ draggableCursor: prevCursor || null });
    };
  }, [map, active, projectId, type, onSaved]);
}

// Inline site/ODC/FAT type selector, rendered inside the control panel while the
// seed tool is active. Wraps to a second row on narrow panels (never overflows).
export function SeedTypePicker({ type, onType }) {
  return (
    <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
      {Object.entries(SEED_FA).map(([k, label]) => {
        const on = type === k;
        return (
          <button
            key={k}
            type="button"
            onClick={() => onType(k)}
            aria-pressed={on}
            style={{
              flex: '1 1 54px', minWidth: 54, padding: '7px 10px', borderRadius: 8,
              cursor: 'pointer', fontWeight: 700, fontSize: 12,
              fontFamily: "'Vazirmatn', sans-serif",
              color: on ? '#0b1220' : '#cbd5e1',
              background: on ? SEED_COLOR[k] : 'rgba(51,65,85,0.55)',
              border: `1px solid ${on ? SEED_COLOR[k] : 'rgba(148,163,184,0.28)'}`,
              transition: 'background 140ms ease, color 140ms ease',
            }}
          >
            {label}
          </button>
        );
      })}
    </div>
  );
}
